module.exports = __webpack_public_path__ + "media/assets/svg/logos/unox_logo_2-f9bed96d1b79088ef4ae51ddfde8a9e0.svg";